// messages.js
export const ToastMessages = {
  REGISTRATION_SUCCESS: 'Registration successful',
  REGISTRATION_FAILURE: 'Registration failed',
  REGISTRATION_ERROR: 'Error during registration',
};

export const DefaultTexts = {
  FORM_TITLE: 'Welcome back to Form Builder!',
  REGISTER_BUTTON: 'Register',
  LOGIN_PROMPT: 'Already have an account? Login',
};
